module.exports = __webpack_public_path__ + "img/2.c90e5a95.jpg";